import { type FC, type SVGProps } from 'react';

export const DoubleChevronRightIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="14"
    fill="currentColor"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillOpacity="0.25"
      fill="currentColor"
      d="M7.3315 6.69219L3.34244 1.59531C3.29557 1.53438 3.22213 1.5 3.14557 1.5H1.93775C1.83307 1.5 1.77525 1.62031 1.83932 1.70156L5.98619 7L1.83932 12.2984C1.82489 12.3169 1.81594 12.339 1.81348 12.3622C1.81103 12.3855 1.81518 12.409 1.82544 12.43C1.83571 12.4511 1.85169 12.4688 1.87155 12.4811C1.89141 12.4935 1.91435 12.5001 1.93775 12.5H3.14557C3.22213 12.5 3.29557 12.4641 3.34244 12.4047L7.3315 7.30938C7.47369 7.12656 7.47369 6.87344 7.3315 6.69219ZM12.0815 6.69219L8.09244 1.59531C8.04557 1.53438 7.97213 1.5 7.89557 1.5H6.68775C6.58307 1.5 6.52525 1.62031 6.58932 1.70156L10.7362 7L6.58932 12.2984C6.57489 12.3169 6.56594 12.339 6.56348 12.3622C6.56103 12.3855 6.56518 12.409 6.57544 12.43C6.58571 12.4511 6.60169 12.4688 6.62155 12.4811C6.64141 12.4935 6.66435 12.5001 6.68775 12.5H7.89557C7.97213 12.5 8.04557 12.4641 8.09244 12.4047L12.0815 7.30938C12.2237 7.12656 12.2237 6.87344 12.0815 6.69219Z"
    />
  </svg>
);
